import { render, staticRenderFns } from "./advantage-phone.vue?vue&type=template&id=0e924d7e&scoped=true&"
import script from "./advantage-phone.vue?vue&type=script&lang=js&"
export * from "./advantage-phone.vue?vue&type=script&lang=js&"
import style0 from "./advantage-phone.vue?vue&type=style&index=0&id=0e924d7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e924d7e",
  null
  
)

export default component.exports